import React from 'react'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'
import styled from 'styled-components'

const BlockContainer = styled.section`
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	grid-template-rows: minmax(auto, 50vh);
	grid-gap: 12px;

	@media (min-width: 768px) {
		grid-gap: 24px;
	}

	@media (min-width: 1200px) {
	}
`

const TextContainer = styled.div`
	grid-row: 2;
	grid-column: 1 / span 12;

	@media (min-width: 768px) {
		grid-column: 1 / span 6;
		grid-row: 1;
	}
`

const TextContainerSwitched = styled(TextContainer)`
	@media (min-width: 768px) {
		grid-column: 7 / span 6;
	}
`

const ImageContainer = styled.div`
	grid-row: 1;
	grid-column: 1 / span 12;
	/* height: fill-available; */
	/* width: fill-available; */

	& > * {
		height: 100%;

		object-fit: contain;
		object-position: 0% 50%;
	}

	@media (min-width: 768px) {
		grid-column: 7 / span 6;
	}
`

const ImageContainerSwitched = styled(ImageContainer)`
	@media (min-width: 768px) {
		grid-column: 1 / span 6;
	}
`

const Heading = styled.h1`
	/* width: 30.5%; */
	font-size: 18px;
	font-weight: 500;

	border-top: 2px solid var(--primary-colour);
	padding-top: 12px;

	@media (min-width: 768px) {
		width: 30.5%;
		font-size: 24px;
	}
`

const Paragraph = styled.p`
	font-size: 14px;
	line-height: 1.4;
	margin-top: 12px;

	@media (min-width: 768px) {
		font-size: 16px;
		/* margin-top: 24px; */
	}
`

const LinkOutIcon = styled.svg`
	transform: translateY(3px);
	width: 16px;
	height: 16px;
	margin-left: 10px;

	& > g > polyline,
	& > g > line {
		fill: none;
		stroke: var(--primary-colour);
		stroke-miterlimit: 10;
	}
`

const TextAndImageBlock = props => (
	<BlockContainer>
		{props.switch === true ? (
			<TextContainerSwitched>
				{props.heading !== '' ? <Heading>{props.heading}</Heading> : null}
				{props.paragraphs !== ['']
					? props.paragraphs.map((paragraph, index) => (
						<Paragraph key={index}>{paragraph}</Paragraph>
					  ))
					: null}
				{props.link !== null ? (
					<Paragraph>
						<a href={props.link.url} name="link-box">
							{props.link.label}
							<LinkOutIcon
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 16 16"
							>
								<g>
									<polyline points="15.5,8 15.5,15.5 0.5,15.5 0.5,0.5 8,0.5 	" />
								</g>
								<g>
									<polyline points="10.5,0.5 15.5,0.5 15.5,5.5 	" />
									<line x1="8.5" y1="7.5" x2="15.5" y2="0.5" />
								</g>
							</LinkOutIcon>
						</a>
					</Paragraph>
				) : null}
			</TextContainerSwitched>
		) : (
			<TextContainer>
				{props.heading !== '' ? <Heading>{props.heading}</Heading> : null}
				{props.paragraphs !== ['']
					? props.paragraphs.map((paragraph, index) => (
						<Paragraph key={index}>{paragraph}</Paragraph>
					  ))
					: null}
				{props.link !== null ? (
					<Paragraph>
						<a href={props.link.url} name="link-box">
							{props.link.label}
							<LinkOutIcon
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 16 16"
							>
								<g>
									<polyline points="15.5,8 15.5,15.5 0.5,15.5 0.5,0.5 8,0.5 	" />
								</g>
								<g>
									<polyline points="10.5,0.5 15.5,0.5 15.5,5.5 	" />
									<line x1="8.5" y1="7.5" x2="15.5" y2="0.5" />
								</g>
							</LinkOutIcon>
						</a>
					</Paragraph>
				) : null}
			</TextContainer>
		)}
		{props.switch === true ? (
			<ImageContainerSwitched>
				<Img
					fluid={props.imageData.childImageSharp.fluid}
					alt={props.altText}
					imgStyle={props.contain === true ? { objectFit: 'contain' } : null}
				/>
			</ImageContainerSwitched>
		) : (
			<ImageContainer>
				<Img
					fluid={props.imageData.childImageSharp.fluid}
					alt={props.altText}
					imgStyle={props.contain === true ? { objectFit: 'contain' } : null}
				/>
			</ImageContainer>
		)}
	</BlockContainer>
)

TextAndImageBlock.propTypes = {
	switch: PropTypes.bool,
	heading: PropTypes.string,
	paragraphs: PropTypes.array,
	imageData: PropTypes.shape({
		childImageSharp: PropTypes.shape({
			fluid: PropTypes.object.isRequired
		}).isRequired
	}).isRequired,
	altText: PropTypes.string.isRequired,
	contain: PropTypes.bool,
	link: PropTypes.object
}

TextAndImageBlock.defaultProps = {
	switch: false,
	heading: 'largeTextLeft',
	paragraphs: [
		'In et similique libero dolores laborum. Voluptas nihil eius sit cum reiciendis. Voluptatum ad corporis quasi a id aut. Pariatur nulla est laborum ea ut et tempore. Et deserunt et ut ut ea qui asperiores. Atque quia unde occaecati.',
		'Tenetur iusto accusamus perspiciatis porro debitis neque dolor. Et iusto id quidem aut autem. Distinctio accusamus officiis aspernatur temporibus. Et id autem excepturi tempore. Nesciunt doloribus hic labore vel.'
	],
	altText: 'Placeholder Alt Text',
	contain: false,
	link: null
}

export default TextAndImageBlock
